import _ from 'lodash'
import { AutoComplete } from 'primereact/autocomplete'
import { useEffect, useState } from 'react'

import { Flex } from '../../../../Components'
import { FieldWrapper } from '../../../../Components/Form'
import { FC } from '../../../../Services'
import { cap } from '../../../../State'
import { translations } from '../../../../translations'
import { showToast } from '../../../../utils/toast'

const language = cap.language.state || 'IT'
const lang = language.toLowerCase()
const t = translations[language] || translations.IT

export const ClientCodeInput = ({
  state: [state, setState],
  valueCode: [clientCode, setClientCode],
  valueRS: [ragioneSociale, setRagioneSociale],
  itemCode,
  itemRS,
  count,
  readOnly,
  variant
}) => {
  const { label } = itemCode
  const [suggestionsCode, setSuggestionsCode] = useState([])
  const [suggestionsRS, setSuggestionsRS] = useState([])

  useEffect(() => {}, [clientCode])

  const debounceSearch = _.debounce(async ({ queryKey, event, setSuggestions }) => {
    const value = event.query.trim()
    if (value.length < 3) {
      setSuggestions([])
      return
    }

    try {
      const { data: suggestions } = await FC.service('info').get('searchClient', {
        query: { [queryKey]: value }
      })

      const filteredSuggestions = suggestions
        .filter((client) => client?.datiGeneraliCliente?.[queryKey])
        .map((client) => ({
          codCliente12: client?.datiGeneraliCliente?.codCliente12,
          ragioneSociale: client?.datiGeneraliCliente?.ragioneSociale
        }))

      setSuggestions(filteredSuggestions)
    } catch (error) {
      setSuggestions([])
      return showToast('error', t.errore, t.ggErroreRicercaCliente)
    }
  }, 500)

  const debounceSearchCode = (event) =>
    debounceSearch({ queryKey: 'codCliente12', event, setSuggestions: setSuggestionsCode })

  const debounceSearchRS = (event) =>
    debounceSearch({ queryKey: 'ragioneSociale', event, setSuggestions: setSuggestionsRS })

  if (variant === 'v2') {
    return (
      <>
        <div className="ff-grid__item">
          <FieldWrapper id={itemRS.id} label={itemRS.label?.[lang] || itemRS.label?.it}>
            <AutoComplete
              disabled={readOnly}
              id={itemRS.id}
              inputId="ragioneSociale"
              value={ragioneSociale || ''}
              suggestions={suggestionsRS}
              completeMethod={debounceSearchRS}
              onChange={({ value }) => {
                setRagioneSociale(value)
                setClientCode('')
              }}
              onSelect={({ value }) => {
                setClientCode(value?.codCliente12)
                setRagioneSociale(value?.ragioneSociale)
              }}
              inputStyle={{ width: '100%' }}
              style={{ width: '100%' }}
              forceSelection
              field="ragioneSociale"
            />
          </FieldWrapper>
        </div>
        <div className="ff-grid__item">
          <FieldWrapper id={itemCode.id} label={label?.[lang] || label?.it}>
            <AutoComplete
              disabled={readOnly}
              id={itemCode.id}
              inputId="clientCode"
              value={clientCode || ''}
              suggestions={suggestionsCode}
              completeMethod={debounceSearchCode}
              onChange={({ value }) => {
                setRagioneSociale('')
                setClientCode(value)
              }}
              onSelect={({ value }) => {
                setRagioneSociale(value?.ragioneSociale)
                setClientCode(value?.codCliente12)
              }}
              inputStyle={{ width: '100%' }}
              style={{ width: '100%' }}
              forceSelection
              field="codCliente12"
            />
          </FieldWrapper>
        </div>
      </>
    )
  }

  return (
    <>
      <Flex key={itemRS.id} as js style={{ width: '23%', margin: '0px 1%' }}>
        <div className="nfield" style={{ marginTop: 25, width: '100%' }}>
          <span className="p-float-label">
            <AutoComplete
              disabled={readOnly}
              id={itemRS.id}
              inputId="ragioneSociale"
              value={ragioneSociale || ''}
              suggestions={suggestionsRS}
              completeMethod={debounceSearchRS}
              onChange={({ value }) => {
                setRagioneSociale(value)
                setClientCode('')
              }}
              onSelect={({ value }) => {
                setClientCode(value?.codCliente12)
                setRagioneSociale(value?.ragioneSociale)
              }}
              inputStyle={{ width: '100%' }}
              style={{ width: '100%' }}
              forceSelection
              field="ragioneSociale"
            />
            <label>{itemRS.label?.[lang] || itemRS.label?.it}</label>
          </span>
        </div>
      </Flex>
      <Flex key={itemCode.id} as js style={{ width: '23%', margin: '0px 1%' }}>
        <div className="nfield" style={{ marginTop: 25, width: '100%' }}>
          <span className="p-float-label">
            <AutoComplete
              disabled={readOnly}
              id={itemCode.id}
              inputId="clientCode"
              value={clientCode || ''}
              suggestions={suggestionsCode}
              completeMethod={debounceSearchCode}
              onChange={({ value }) => {
                setRagioneSociale('')
                setClientCode(value)
              }}
              onSelect={({ value }) => {
                setRagioneSociale(value?.ragioneSociale)
                setClientCode(value?.codCliente12)
              }}
              inputStyle={{ width: '100%' }}
              style={{ width: '100%' }}
              forceSelection
              field="codCliente12"
            />
            <label>{label?.[lang] || label?.it}</label>
          </span>
        </div>
      </Flex>
    </>
  )
}
